'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var probe = require('./probe.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);

/**
 * Express middleware for a simple health check.
 * Utilizes the `probeCheck` function to determine if the applications
 * dependencies are healthy.
 *
 * @see @bwoty-web/utils/probe
 *
 * @param {import('express').Request} _req
 * @param {import('express').Response} res
 * @param {Dependency[]} dependencies
 */

var smoke = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(_req, res, dependencies) {
    var result;
    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return probe.probeCheck(dependencies);

          case 3:
            result = _context.sent;

            if ((result === null || result === void 0 ? void 0 : result.status) === 'Error') {
              res.status(500).json(result);
            } else {
              res.status(200).json(result);
            }

            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            res.status(500).json({
              message: 'Internal Server Error'
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function smoke(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.smoke = smoke;
//# sourceMappingURL=smoke.js.map
